<template>
  <strong>
    <img src="/img/icons/apple-touch-icon-76x76.png" alt="" />
    <span :style="'color: #8396a5'">Fortknox</span>
  </strong>
</template>
<script>
export default {
  name: 'VaIconVuestic',
  inject: ['contextConfig'],
  computed: {
    themeGradientId () {
      return this.contextConfig.invertedColor ? 'CORPORATE' : 'ORIGINAL'
    },
    textColor () {
      return this.contextConfig.invertedColor ? '#6E85E8' : '#E4FF32'
    },
  },
}
</script>

<style lang="scss" scope>
strong {
  display: flex;
  align-items: center;
}

img {
  margin-right: 10px;
  max-width: 32px;
}

span {
  color: white;
  font-size: 20px;
}
</style>
